export default {
  brand: 'ブランド',
  dashboard: 'ダッシュボード',
  products: '商品管理',
  antiFake: '偽造対策',
  scanTemplate: 'スキャンテンプレート',
  scanTemplateEditor: 'スキャンテンプレート編集',
  supplyChain: 'サプライチェーン',
  production: '生産管理',
  members: '会員管理',
  marketing: 'マーケティング',
  activityManagement: 'アクティビティ管理',
  activityList: 'アクティビティ一覧',
  activityAdd: 'アクティビティ作成',
  activityEdit: 'アクティビティ編集',
  activityDetail: 'アクティビティ詳細',
  drawRecord: '抽選記録',
  giftClaimRecord: 'ギフト受け取り記録',
  activityTemplate: 'アクティビティテンプレート',
  activityTemplateEditor: 'テンプレートエディタ',
  marketingData: 'マーケティングデータ',
  mall: 'モール',
  dealers: 'ディーラー管理',
  settings: '設定',
  reports: 'レポート',
  code: 'コード管理',
  codeManagement: 'コード管理',
  codeBatchList: 'コードバッチ一覧',
  codeStatusControl: 'コード状態制御',
  antiFakeTrace: '偽造防止トレース',
  productLinkTemplate: '製品関連テンプレート',
  scanDetail: 'スキャン明細',
  alertRecord: '警告記録',
  alertSetting: '警告設定',
  productCodeAssignment: '商品コード割り当て',
  merchants: 'マーチャント管理',
  companyInfo: '会社情報',
  emailConfig: 'メール設定',
  smsConfig: 'SMS設定',
  i18nManagement: '多言語管理',
  paymentAuthConfig: '支払い認証設定',
  systemSettings: 'システム設定',
  roleManagement: 'ロール管理',
  accountManagement: 'アカウント管理',
  operationLog: '操作ログ',
  afterSaleFeedback: 'アフターサービスフィードバック',
  memberList: '会員一覧',
  memberDetail: '会員詳細',
  memberLevelPrivilege: '会員レベル特権',
  memberDecoration: '会員デコレーション',
  blacklistManagement: 'ブラックリスト管理',
  memberManagement: '会員管理',
  memberBasicConfig: '基本設定',
  points: 'ポイント',
  pointsIssueDetail: '付与明細',
  pointsIssueStats: '付与統計',
  pointsConfig: 'ポイント設定',
  pointsMall: 'ポイントモール',
  pointsProduct: 'ポイント商品',
  pointsProductAddEdit: 'ギフト追加/編集',
  pointsProductCategory: '商品カテゴリ',
  exchangeRecord: '交換記録',
  mallDecoration: 'モールデコレーション',
  exchangeStats: '交換統計',
  productLibrary: '製品ライブラリ',
  productList: '製品一覧',
  productAdd: '製品追加',
  productEdit: '製品編集',
  productCategory: '製品カテゴリ',
  productAttribute: '製品属性',
  giftLibrary: 'ギフトライブラリ',
  giftList: 'ギフト一覧',
  giftAdd: 'ギフト追加',
  giftEdit: 'ギフト編集',
  giftCategory: 'ギフトカテゴリ',
  productionInfo: '生産情報',
  productionBatch: '生産バッチ',
  batchAdd: '生産バッチ追加',
  batchEdit: '生産バッチ編集',
  factoryManagement: '工場管理',
  materialLibrary: '素材ライブラリ',
  memberLevelAdd: '会員レベル追加',
  memberLevelEdit: '会員レベル編集',
};
